export default "__VITE_PUBLIC_ASSET__8e6514c4__"